import styled, { css } from 'styled-components';
import createTheme from 'styled-variants';
import { breakpoints, getShadowStyle, pxToRelative, pxToRems, } from '@awaze/design-system.utils.react';
const segmentedControlVariants = ({ theme, variant, }) => css `
  font-size: ${pxToRems(variant === 'small'
    ? theme.FontTextText200MidFontSize
    : theme.FontTextText300MidFontSize)};
  line-height: ${pxToRelative(variant === 'small'
    ? theme.FontTextText200MidLineHeight
    : theme.FontTextText300MidLineHeight)};
`;
export const SegmentedControlStyled = styled.button `
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 0;

  background: none;
  border: none;
  color: ${({ theme }) => theme.ColorThemeLink};

  ${(p) => p.highlight &&
    css `
      font-weight: ${p.theme.FontTextText500MidFontWeight};
    `}

  white-space: nowrap;

  cursor: pointer;

  ${({ isElevated, theme }) => isElevated &&
    css `
      background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
      box-shadow: ${getShadowStyle({ theme, depth: 2 })};
      border-radius: 4px;
      padding: ${pxToRems(12)};
    `}

  ${({ theme, variant }) => css `
      ${segmentedControlVariants({
    theme,
    variant: Array.isArray(variant) ? variant[0] : variant,
})}

      @media screen and (min-width: ${breakpoints[0]}px) {
        ${segmentedControlVariants({
    theme,
    variant: Array.isArray(variant) ? variant[1] : variant,
})}
      }
      @media screen and (min-width: ${breakpoints[1]}px) {
        ${segmentedControlVariants({
    theme,
    variant: Array.isArray(variant) ? variant[2] : variant,
})}
      }
    `}
`;
export const IconStyled = styled.span `
  margin-right: ${pxToRems(12)};
  display: block;

  > svg {
    display: block;

    &,
    & * {
      fill: currentColor !important;
    }
  }
`;
export const BadgeStyled = styled.span `
  margin-left: ${pxToRems(12)};
`;
const segmentedControlsVariants = ({ theme }) => ({
    small: {
        fontSize: pxToRems(theme.FontTextText200MidFontSize),
        lineHeight: pxToRelative(theme.FontTextText200MidLineHeight),
    },
    medium: {
        fontSize: pxToRems(theme.FontTextText300MidFontSize),
        lineHeight: pxToRelative(theme.FontTextText300MidLineHeight),
    },
});
const SegmentedControlsTheme = createTheme('SegmentedControls').addVariant('variant', segmentedControlsVariants);
const SegmentedControlsThemed = styled.div(SegmentedControlsTheme);
export const SegmentedControlsStyled = styled(SegmentedControlsThemed) `
  display: inline-flex;
  flex-direction: row;
  align-items: center;

  ${SegmentedControlStyled} {
    font-size: inherit;
    line-height: inherit;

    ${({ isElevated }) => isElevated &&
    css `
        background-color: none;
        border-radius: none;
        box-shadow: none;
      `}
  }

  > * + * {
    position: relative;
    margin-left: 1px;

    ${({ isElevated }) => !isElevated &&
    css `
        margin-left: ${pxToRems(13)};
        padding-left: ${pxToRems(12)};
      `}

    &::before {
      position: absolute;
      top: 50%;
      left: -1px;
      transform: translateY(-50%);

      display: block;
      height: 100%;
      max-height: ${pxToRems(24)};
      width: 1px;

      background-color: ${({ theme }) => theme.ColorGrey100};

      content: '';
    }
  }

  ${({ isElevated, theme }) => isElevated &&
    css `
      border-radius: 4px;
      box-shadow: ${getShadowStyle({ theme, depth: 2 })};
      background-color: ${({ theme }) => theme.ColorWhiteOpacity100};

      ${SegmentedControlStyled} {
        padding: ${pxToRems(12)};
      }
    `}
`;
export const SegmentedControlsOverflow = styled.div `
  overflow-x: auto;
  width: 100%;
  white-space: nowrap;
`;
//# sourceMappingURL=segmented-control.styles.js.map